/**
 * 결재 목록 검색 파라미터 빌더.
 *
 * 통합/제목/내용 3갈래 검색어를 BE 검색 파라미터로 매핑한다(값 있는 것끼리 AND).
 * - 통합(keyword)           → query          : 고급 문법(query_string)을 그대로 전달
 * - 제목 칩(titleKeyword)   → titleKeyword   : 일반 텍스트 파라미터(문법 해석 없음 → 문법오류 400 없음)
 * - 내용 칩(contentKeyword) → contentKeyword : 〃
 *
 * 제목+내용 칩이 둘 다 있으면 keywordCondition='and' 를 함께 보낸다.
 * (BE 는 title/content 가 모두 있을 때만 이 값을 보며, 미전송 시 OR 로 묶어
 * 제목 '또는' 내용만 맞는 문서가 노출되는 false-positive 가 생긴다)
 *
 * 레거시 하위호환: '제목만/내용만'(searchFields)으로 저장된 '내 필터'(favorites)의
 * keyword 는 각각 titleKeyword/contentKeyword 로 좁혀 저장 당시 검색 의미를 유지한다.
 * (같은 필드의 칩 값과 겹치면 공백으로 이어 함께 검색)
 *
 * BE 제약: query 는 2~500자 → 2자 미만이면 미전송. 입력 상한은 UI maxLength 로 방어.
 */
type ApprovalSearchInput = {
  keyword?: string;
  searchFields?: string;
  titleKeyword?: string;
  contentKeyword?: string;
};

export type ApprovalSearchParams = {
  query?: string;
  titleKeyword?: string;
  contentKeyword?: string;
  keywordCondition?: 'and' | 'or';
};

export const buildApprovalSearchParams = ({
  keyword,
  searchFields,
  titleKeyword,
  contentKeyword,
}: ApprovalSearchInput): ApprovalSearchParams => {
  const unified = keyword?.trim() ?? '';
  const isLegacyTitleOnly = searchFields === 'subject';
  const isLegacyContentOnly = searchFields === 'content';

  const title = [isLegacyTitleOnly ? unified : '', titleKeyword?.trim()]
    .filter(Boolean)
    .join(' ');
  const content = [isLegacyContentOnly ? unified : '', contentKeyword?.trim()]
    .filter(Boolean)
    .join(' ');
  const query =
    !isLegacyTitleOnly && !isLegacyContentOnly && unified.length >= 2
      ? unified
      : undefined;

  return {
    query,
    titleKeyword: title || undefined,
    contentKeyword: content || undefined,
    keywordCondition: title && content ? 'and' : undefined,
  };
};
